import { translationNavigation_en_part1 } from "./translationNavigation.en.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationNavigation_en_part2 } from "./translationNavigation.en.part2";
import { translationNavigation_en_part3 } from "./translationNavigation.en.part3";

export const translationNavigation_en = defineTranslationTree({
  ...translationNavigation_en_part1,
  ...translationNavigation_en_part2,
  ...translationNavigation_en_part3,
});
